import { DataSourceParams, GetManyDto } from '@fleet-beat/core';

export interface InfiniteListParams<Extra> extends DataSourceParams<GetManyDto, Extra> {}
